import { useLocation } from '@Alias/hooks';
import { matchPath } from '@Alias/utils';
import { useCallback } from 'react';
import { DynamicPath } from '../../constants/router';
import { page } from '../../redux/actions/analytics';
import { getIsFASTSignUp, getSignupStep } from '../../redux/selectors/billing';
import { getLaunchPageType } from '../../redux/selectors/launch';
import { SignupPageTitle, getPageTitle, isSignupPath } from '../../utils/router';
import useLatest from '../../web-shared/hooks/use-latest';
import {
  getSubscriptionCode,
  getSubscriptionCodeType,
} from '../../web-shared/redux/selectors/shared-billing';
import { OfferType } from '../../web-shared/types/billing';
import { VALID_FAST_PATHS } from '../fast/use-fast-signup-flow-tracker';
import useAppStore from '../use-app-store';

export const FAST_PREFIX = 'Fast';

/** KU
 *
 * Returns a handler, {@link handlePageTrack}, which dispatches a page event and
 * includes routing information in the payload. This handler also ensures the
 * the correct pathname and page title for in-app pages and flows like
 * multi-step signup.
 */
export function usePageTrack() {
  const { dispatch, getState } = useAppStore();
  const location = useLatest(useLocation());

  const handlePageTrack = useCallback((props: Record<string, string> = {}) => {
    const {
      current: { pathname },
    } = location;

    const state = getState();
    const signupStep = getSignupStep(state);
    const couponType = getSubscriptionCodeType(state) === OfferType.COUPON;
    const couponCode = couponType ? getSubscriptionCode(state) : '';
    const isFASTSignUp = getIsFASTSignUp(state);

    const title = getPageTitle(pathname);

    const isInFASTflow = isFASTSignUp && VALID_FAST_PATHS.includes(pathname);
    const pageTitle = `${isInFASTflow ? FAST_PREFIX : ''}${
      (isSignupPath(pathname) && SignupPageTitle[Number(signupStep)]) ||
      title ||
      (!matchPath(DynamicPath.GO, pathname) && getLaunchPageType(state)) ||
      pathname
    }`;

    dispatch(
      page(pageTitle, {
        path: pathname,
        ...(couponCode && { coupon_code: couponCode }),
        ...props,
      }),
    );
  }, []);

  return { handlePageTrack };
}
